module.exports = __webpack_public_path__ + "img/help_statusbar.ec491a94.png";